module.exports = "/static/media/cross_cancel_icon.e07dc163.svg";